export default __webpack_public_path__ + "static/media/toggle.16d3aa23.svg";